import { useRisksSpace } from "@/core/risks-space.context"
import { useAppDispatch } from "@/core/root-reducer"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import riskFamilyStore from "@/entities/risk-family/model/risk-family.store"
import { RISK_FAMILIES_PATH } from "@/entities/risk-family/model/risk-family.utils"
import { useNavigate } from "react-router-dom"

/** Ouvre la mosaique des familles. Comme un clic sur l'onglet : un risque ou une
 *  famille reste actif apres sa consultation, et la page afficherait sa carte au lieu de la mosaique. */
export default function useOpenRiskCatalog() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()

  return () => {
    dispatch(riskFamilyStore.actions.setActive(null))
    dispatch(physicalRiskStore.actions.setActive(null))
    navigate(getPath(RISK_FAMILIES_PATH))
  }
}
